/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Locallogin_Formdescription2Inputs */

const en_locallogin_formdescription2 = /** @type {(inputs: Locallogin_Formdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Local session — mints a backend SESSION cookie for the email below via session-service. Available only when running on localhost.`)
};

/**
* | output |
* | --- |
* | "Local session — mints a backend SESSION cookie for the email below via session-service. Available only when running on localhost." |
*
* @param {Locallogin_Formdescription2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const locallogin_formdescription2 = /** @type {((inputs?: Locallogin_Formdescription2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Locallogin_Formdescription2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_locallogin_formdescription2(inputs)
});
export { locallogin_formdescription2 as "localLogin_formDescription" }